__turbopack_context__.v({
  "regular-14": "JwGrYa_regular-14" + " " + "JwGrYa_typography",
  "regular-16": "JwGrYa_regular-16" + " " + "JwGrYa_typography",
  "regular-18": "JwGrYa_regular-18" + " " + "JwGrYa_typography",
  "regular-22": "JwGrYa_regular-22" + " " + "JwGrYa_typography",
  "regular-26": "JwGrYa_regular-26" + " " + "JwGrYa_typography",
  "semi-bold-15": "JwGrYa_semi-bold-15" + " " + "JwGrYa_typography",
  "semi-bold-18": "JwGrYa_semi-bold-18" + " " + "JwGrYa_typography",
  "semi-bold-22": "JwGrYa_semi-bold-22" + " " + "JwGrYa_typography",
  "semi-bold-26": "JwGrYa_semi-bold-26" + " " + "JwGrYa_typography",
  "semi-bold-36": "JwGrYa_semi-bold-36" + " " + "JwGrYa_typography",
  "semi-bold-48": "JwGrYa_semi-bold-48" + " " + "JwGrYa_typography",
  "semi-bold-72": "JwGrYa_semi-bold-72" + " " + "JwGrYa_typography",
  "semi-bold-96": "JwGrYa_semi-bold-96" + " " + "JwGrYa_typography",
  "tagline-26": "JwGrYa_tagline-26" + " " + "JwGrYa_typography",
  "tagline-32": "JwGrYa_tagline-32" + " " + "JwGrYa_typography",
  "typography": "JwGrYa_typography",
});
